import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m17.688 7.786-.705 10.232c-.06.881-.768 1.565-1.621 1.565H8.638c-.852 0-1.56-.684-1.62-1.565L6.312 7.786m4.062 3.37v5.056m3.25-5.055v5.055m.813-8.426V5.26c0-.466-.364-.843-.813-.843h-3.25c-.449 0-.813.377-.813.843v2.527m-4.062 0h13",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render };